<template>
    <div class="row mt-3">
        <div class="col-xl-6 col-lg-12">
            <div class="mb-3">
                <strong>Danh sách điểm</strong>
            </div>
            <b-table responsive striped hover sticky-header :fields="fieldsTableMember" :items="listMember" class="b-table-list">
                <template #head(stt)="data">
                    <span class="col-table">{{ data.label }}</span>
                </template>
                <template #head(name)="data">
                    <span class="col-table">{{ data.label }}</span>
                </template>
                <template #cell(stt)="row">
                    {{ row.item.stt }}
                </template>
                <template #cell(memberName)="row">
                    {{ row.item.memberName }}
                </template>
                <template #cell(status)="row">
                    {{ row.item.status }}
                </template>
                <template #cell(point)="row">
                    {{ row.item.point != null ? formatNumber(row.item.point) : '-' }}
                </template>
                <template #table-caption v-if="listMember.length == 0">Chưa có dữ liệu điểm</template>
            </b-table>
        </div>
        <div class="col-xl-6 col-lg-12">
            <div class="mb-3">
                <strong>Thống kê kết quả</strong>
            </div>
            <div class="chart-complete-ratio">
                <vueCustomScrollbar class="list-question-scroll">
                    <label class="text-question-title">
                        Danh sách các câu hỏi có tỷ lệ sai cao
                    </label>
                    <div class="question-list">
                        <div v-if="listQuestionRateFalse.length > 0" class="question-item" v-for="(item, index) of listQuestionRateFalse">
                            <div class="q-top">
                                <p class="text-primary m-0 float-left">Câu {{ index + 1 }}: &nbsp;</p> 
                                <p class="m-0 float-left" v-if="item.content" v-html="item.content">
                                </p>
                                <span class="m-0 float-left" v-else>Câu hỏi chưa có nội dung</span>
                            </div>
                            <div class="q-bottom display-flex-center">
                                <strong>Tỉ lệ câu sai: </strong>
                                {{ item.countMemberAnswerFalse * 1 }}/{{ item.countMemberAnwer * 1 }}
                            </div>
                        </div>
                        <div v-if="listQuestionRateFalse.length == 0" class="no-data">
                            Dữ liệu đang được cập nhật...
                        </div>
                    </div>
                </vueCustomScrollbar>
            </div>
            <div class="chart-complete-ratio my-4 px-0">
                <vueCustomScrollbar class="chart-scroll">
                    <div class="chart-header">
                        <label class="text-question-title">
                            Biểu đồ điểm trong lớp
                        </label>
                        <h4>{{ listMember.length }}</h4>
                        <label class="text-question-title">bài</label>
                    </div>
                    <div class="chart-area px-3">
                        <ChartPointInClass :classSchoolId="classSchoolId" :lessonClassSchoolId="lessonClassSchoolId" />
                    </div>
                </vueCustomScrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ChartPointInClass from './ChartPointInClass'
import { getListUserExcerice, getQuestionExcerciseRateFalse } from './../../_api/lessonClassSchoolUserServices';
import { APP_CONFIG } from "@/utils/constants";
import { setContentMediaEditorShow } from "@/modules/question/preview-question/_store/helperQuestionContent";

export default {
    components:{
        vueCustomScrollbar,
        ChartPointInClass
    },
    props: {
        listGroupId: {
            type: Number,
            default: 0
        },
        classSchoolId: {
            type: Number,
            default: 0
        },
        lessonClassSchoolId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            paramQueryDataQuestion: {
                keyword: '',
                pageIndex: 1,
                pageSize: 3,
                lessonClassSchoolId: 0,
                listGroupId: 0,
                classSchoolId: 0,
            },
            paramQueryDataMember: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
                classSchoolId: 0,
                lessonClassSchoolId: 0,
                isGetByAll: true
            },
            fieldsTableMember: [
                { key: 'stt', label: 'STT', thClass: 'w-60px text-center', tdClass: 'w-60px text-center' }, 
                { key: 'memberName', label: 'Tên học sinh' }, 
                { key: 'status', label: 'Trạng thái', thClass: 'w-150px text-center', tdClass: 'w-150px text-center' }, 
                { key: 'point', label: 'Điểm', thClass: 'w-150px text-center', tdClass: 'w-150px text-center' }, 
            ],
            listMember: [],
            listQuestionRateFalse: [],
            urlQuestionImg: APP_CONFIG.urlQuestionImg,
        }
    },
    watch: {
        'classSchoolId': 'getDataAll',
    },
    mounted(){
        if (this.classSchoolId > 0) {
            this.getDataAll()
        }
    },
    methods:{
        moment,
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            if (value % 1 == 0.5) {
                return value.toFixed(1);
            }
            return value.toFixed(0);
        },
        getDataAll() {
            this.getQuestionRateFalse()
            this.getListMember()
        },
        getQuestionRateFalse() {
            this.listQuestionRateFalse = []
            this.paramQueryDataQuestion.lessonClassSchoolId = this.lessonClassSchoolId
            this.paramQueryDataQuestion.listGroupId = this.listGroupId
            this.paramQueryDataQuestion.classSchoolId = this.classSchoolId
            getQuestionExcerciseRateFalse(this.paramQueryDataQuestion).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        let itemTemp = setContentMediaEditorShow(item)
                        this.listQuestionRateFalse.push(itemTemp);
                    }
                }
            })
        },
        getListMember() {
            this.listMember = []
            this.paramQueryDataMember.classSchoolId = this.classSchoolId
            this.paramQueryDataMember.lessonClassSchoolId = this.lessonClassSchoolId
            getListUserExcerice(this.paramQueryDataMember).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        this.listMember.push({ 
                            'stt': i + 1,
                            'memberName': item.userName,
                            'status': item.status,
                            'point': item.point,
                        })
                    }
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.chart-complete-ratio {
    padding: 0.5rem 2rem;
    border: 1px solid #dee2e6;
    border-radius: 0.6rem;
    min-height: 8rem;
}
.header-table .col-header{
    color: #94a3b0;
    padding: 0.3rem 1rem;
}
.col-cell {
    padding: 0.3rem 1rem;
}
.icon-edit {
    width: 15px;
    cursor: pointer;
}
.width-60 {
    width: 60px;
}
.question-list {
    display: flex;
    //align-items: center;
    flex-direction: column;
    row-gap: 1rem;
}
.question-item {
    display: flex;
    flex-direction: column;
    row-gap: 1.2rem;
}
.table-list-member {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
}
.list-question-scroll {
    max-height: 30vh;
    overflow-y: auto;
}
.float-left {
    float: left;
}
.text-question-title {
    color: #898989;
}
.chart-header {
    padding: 1rem 2rem;
    border-bottom: 1px solid #ced4da;
    margin-bottom: 1rem;
}
</style>